import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';

import { INewbuildingsCompareCard } from '../../hooks/useCompareCards';
import * as style from '../../style.css';
import { CompareRow } from '../CompareRow';

export interface ICompareCardProps {
  card: INewbuildingsCompareCard;
  pinnedIndex: number | null;
  registerCell(id: string): (node: HTMLDivElement | null) => void;
}

export const CompareCard = ({ card, pinnedIndex, registerCell }: ICompareCardProps) => (
  <div className={style['card']} data-testid="newbuildings-compare-mobile_card" role="rowgroup">
    <div className={style['card-content']} role="presentation">
      {card.header && (
        <div className={style['block-row']} role="row">
          {card.header.imageUrl && (
            <span className={style['block-icon']}>
              <img alt="" height={16} src={card.header.imageUrl} width={16} />
            </span>
          )}
          <UIHeading2>{card.header.title}</UIHeading2>
        </div>
      )}
      {card.rows.map(row => (
        <CompareRow key={row.key} pinnedIndex={pinnedIndex} registerCell={registerCell} row={row} />
      ))}
    </div>
  </div>
);
